export var featherInternalLocaleIdentifier = '_fili';
export var featherInternalRegionIdentifier = '_firi';
export { detectLocale } from './detectLocale';
export { setCookieLocale } from './setCookieLocale';
export { getCookieRegion, setCookieRegion } from './cookieRegion';
